const apiUrl = "https://api.sak.legal24.no";
const socketUrl = "https://api.sak.legal24.no";
const authUrl = "https://auth.legal24.no";
const redirectUri = "https://api.sak.legal24.no/auth/callback";
const frontendUri = "https://sak.legal24.no";
const stripe = "pk_test_CuifsYQ1RfrniUIpSkB2gbyG00Y9C2iJUC";

export { apiUrl, authUrl, socketUrl, redirectUri, frontendUri, stripe };
